module.exports = __webpack_public_path__ + "static/media/image-5.98a1d41e.png";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/Blog/FBGroup/image-5.png
// module id = 458
// module chunks = 0